export const arabicTranslations = {
  "View details": "عرض التفاصيل",
  "Hide details": "إخفاء التفاصيل",
  "Choose {count} libraries": "اختر {count} مكتبات",
  "Exercise feeling": "الشعور أثناء التمرين",
  "Bad": "سيئ",
  "Good": "جيد",
  "Very good": "جيد جداً",
  "Excellent": "ممتاز",
  "Page": "صفحة",
  "Could not save your performance. Please try again.": "تعذر حفظ أدائك. يرجى المحاولة مجدداً.",
  "THE HYBRID PERFORMANCE PROGRAM": "برنامج الأداء الهجين",
  "THE HYBRID BLUEPRINT": "مخططك التدريبي الهجين",
  "Personalized program": "برنامج شخصي",
  "YOUR GOAL. YOUR BODY. YOUR SYSTEM.": "هدفك. جسدك. نظامك التدريبي.",
  "A personalized training program designed around your goals, training experience, schedule, equipment and lifestyle.": "برنامج تدريبي شخصي يُبنى حول أهدافك وخبرتك وجدولك والمعدات المتاحة ونمط حياتك.",
  "Complete HPA delivery": "تجربة متكاملة عبر الأكاديمية",
  "Your program and exercise videos, organized in one place.": "برنامجك وفيديوهات تمارينك منظّمة في مكان واحد.",
  "Your blueprint includes": "ما يتضمنه مخططك",
  "Comprehensive training questionnaire": "استبيان تدريبي شامل",
  "Goal assessment": "تقييم دقيق للأهداف",
  "Personalized program design": "تصميم برنامج شخصي",
  "Weekly training structure": "هيكل تدريبي أسبوعي",
  "Exercise selection": "اختيار التمارين المناسبة",
  "Sets, reps and progression guidance": "إرشادات المجموعات والتكرارات والتدرّج",
  "Training instructions": "تعليمات تدريبية واضحة",
  "Full exercise video access": "وصول كامل إلى فيديوهات التمارين",
  "Program delivered through HPA": "تقديم البرنامج عبر منصة الأكاديمية",
  "Start your application": "ابدأ طلبك",
  "Request Your Program": "اطلب برنامجك",
  "Tell us about your goals and training background. Your request will be reviewed before your personalized program is prepared.": "أخبرنا عن أهدافك وخلفيتك التدريبية. سنراجع طلبك قبل إعداد برنامجك الشخصي.",
  "Warm-up": "الإحماء",
  "Main Workout": "التمرين الرئيسي",
  "Prepare to perform": "استعدّ لتقديم أفضل أداء",
  "Primary training block": "الجزء التدريبي الأساسي",
  "HYBRID PERFORMANCE ACADEMY": "أكاديمية الأداء الهجين",
  "BUILD THE BODY.": "ابنِ جسدك.",
  "DEVELOP THE ATHLETE.": "وطوّر أداءك الرياضي.",
  "Train for muscle, strength and performance—without sacrificing one for the other.": "طوّر كتلتك العضلية وقوتك وأداءك معاً، من دون أن تضحي بأي جانب منها.",
  "One complete platform for hypertrophy, athletic performance, mobility and kettlebell training. Explore thousands of professionally demonstrated exercises and train with purpose—whether your goal is to build your physique, improve performance or do both.": "منصة متكاملة لبناء العضلات وتطوير الأداء الرياضي والحركة والتدريب بالكرة الحديدية. اكتشف آلاف التمارين المشروحة باحتراف وتدرّب وفق هدف واضح، سواء أردت بناء قوامك أو الارتقاء بأدائك أو الجمع بينهما.",
  "WHY HPA IS DIFFERENT": "لماذا تتميّز أكاديمية الأداء الهجين",
  "DON'T TRAIN IN ONE DIMENSION.": "لا تحصر تدريبك في بُعد واحد.",
  "Training should develop more than how you look. Compare random workouts with a complete performance system.": "يجب أن يطوّر التدريب قدراتك، لا مظهرك فقط. اكتشف الفرق بين التمارين العشوائية ومنظومة الأداء المتكاملة.",
  "The conventional way": "النهج التقليدي",
  "Traditional Training": "التدريب التقليدي",
  "Train without limits": "تدرّب بلا حدود",
  "Hybrid Performance Academy": "أكاديمية الأداء الهجين",
  "THE COMPLETE SYSTEM": "المنظومة المتكاملة",
  "Train for appearance only": "التدريب من أجل المظهر فقط",
  "Build physique + performance": "بناء القوام وتطوير الأداء",
  "Random exercise selection": "اختيار عشوائي للتمارين",
  "Structured training": "تدريب منظّم ومدروس",
  "Search endlessly online": "بحث متواصل ومشتّت عبر الإنترنت",
  "Everything organized": "كل ما تحتاجه منظّم بوضوح",
  "One training method": "أسلوب تدريبي واحد",
  "Multiple performance systems": "أنظمة متعدّدة لتطوير الأداء",
  "Generic fitness advice": "نصائح رياضية عامة",
  "Purpose-driven training": "تدريب موجّه نحو أهدافك",
  "Built for complete performance": "مصمّم لأداء متكامل",
  "Your body wasn't built for one thing. Your training shouldn't be either.": "جسدك لم يُخلق لأداء مهمة واحدة، وكذلك تدريبك يجب أن يتجاوز بُعداً واحداً.",
  "Join the Academy": "انضم إلى الأكاديمية",
  "Home": "الرئيسية",
  "About Us": "من نحن",
  "Libraries": "المكتبات التدريبية",
  "BMI Calculator": "حاسبة مؤشر كتلة الجسم",
  "Nutrition Guide": "دليل التغذية",
  "Contact Us": "تواصل معنا",
  "My Schedule": "جدولي التدريبي",
  "LOGIN": "تسجيل الدخول",
  "LOGOUT": "تسجيل الخروج",
  "Our Socials": "تابعنا",
  "Online Platform": "منصة تدريب رقمية",
  "Train Anywhere": "تدرّب أينما كنت",
  "Access Hybrid Performance Academy from home, the gym, or wherever you train.": "استفد من برامج أكاديمية هايبرد بيرفورمانس في المنزل أو النادي أو أينما اخترت أن تتدرّب.",
  "Copyright © {year}. All rights reserved.": "حقوق النشر © {year}. جميع الحقوق محفوظة.",
  "Train with a clear structure": "تدرّب وفق منهجية واضحة",
  "Explore Our Libraries": "استكشف مكتباتنا التدريبية",
  "Choose the training system that fits your goals. Your active package determines which libraries you can open.": "اختر المنهج التدريبي الأنسب لأهدافك. وتحدّد باقتك النشطة المكتبات المتاحة لك.",
  "Library": "المكتبة التدريبية",
  "Browse categories and videos in this library. Click a video to start watching.": "تصفّح التصنيفات والمقاطع ضمن هذه المكتبة، ثم اختر المقطع الذي ترغب في مشاهدته.",
  "Video categories": "تصنيفات الفيديو",
  "Loading library…": "جارٍ تحميل المكتبة…",
  "Loading video…": "جارٍ تحميل الفيديو…",
  "No category selected": "لم يتم اختيار أي تصنيف",
  "No videos available yet": "لا تتوفر مقاطع فيديو حالياً",
  "Content will be added soon.": "سيتم إضافة محتوى جديد قريباً.",
  "Category": "التصنيف",
  "Subcategory": "التصنيف الفرعي",
  "Subscription Required": "يتطلب اشتراكاً",
  "Unlock {name}": "افتح مكتبة {name}",
  "Choose a plan below to get access.": "اختر إحدى الباقات التالية للوصول إلى المحتوى.",
  "Log in or create an account, then subscribe to get access.": "سجّل الدخول أو أنشئ حساباً، ثم اشترك للوصول إلى المحتوى.",
  "No packages available at the moment.": "لا تتوفر باقات في الوقت الحالي.",
  "{days} days": "{days} يوماً",
  "Includes access to": "تشمل الوصول إلى",
  "Subscribe": "اشترك الآن",
  "Log In to Subscribe": "سجّل الدخول للاشتراك",
  "Welcome back,": "مرحباً بعودتك،",
  "Athlete": "أيها الرياضي",
  "Ready to make today count?": "هل أنت مستعد لتصنع فرقاً اليوم؟",
  "Your first win starts here": "خطوتك الأولى نحو الفوز تبدأ هنا",
  "Train smart. Play the challenge. Win a free month.": "تدرّب بذكاء، خُض التحدي، واربح شهراً مجانياً.",
  "Create your free account and take the Hybrid Performance Challenge for your chance to unlock a one-month subscription—on us.": "أنشئ حسابك مجاناً وشارك في تحدي هايبرد بيرفورمانس لتحصل على فرصة الفوز باشتراك مجاني لمدة شهر.",
  "Register & Take the Challenge": "سجّل وابدأ التحدي",
  "No payment required to create your account.": "إنشاء الحساب لا يتطلب أي دفع.",
  "Measured progress": "تقدّم يمكن قياسه",
  "Numbers that rise with the work.": "أرقام تنمو بقدر ما تبذله من جهد.",
  "Daily standard": "معيارك اليومي",
  "Move with purpose. Train with intent.": "تحرّك بهدف، وتدرّب بتركيز.",
  "Push through every rep, lock in your discipline, and turn every workout into proof of what you are building.": "التزم بكل تكرار، ورسّخ انضباطك، واجعل كل حصة تدريبية دليلاً على ما تبنيه.",
  "OUR PLANS": "باقاتنا",
  "What Clients Say": "ماذا يقول عملاؤنا",
  "Gym FAQs": "الأسئلة الشائعة",
  "Hybrid Nutrition Guide": "دليل هايبرد للتغذية",
  "Download your nutrition guide and keep it available for meal planning, shopping, and training-day preparation.": "حمّل دليل التغذية واحتفظ به لتخطيط وجباتك وتسوقك واستعدادك لأيام التدريب.",
  "Download PDF": "تحميل الدليل بصيغة PDF",
  "Downloading…": "جارٍ التحميل…",
  "Sign in": "تسجيل الدخول",
  "Create account": "إنشاء حساب",
  "Email": "البريد الإلكتروني",
  "Password": "كلمة المرور",
  "First name": "الاسم الأول",
  "Last name": "اسم العائلة",
  "Forgot password?": "هل نسيت كلمة المرور؟",
  "Reset password": "إعادة تعيين كلمة المرور",
  "Send reset link": "إرسال رابط الاستعادة",
  "Back to login": "العودة إلى تسجيل الدخول",
  "New password": "كلمة المرور الجديدة",
  "Confirm password": "تأكيد كلمة المرور",
  "Close": "إغلاق",
  "ABOUT HYBRID PERFORMANCE ACADEMY": "عن أكاديمية هايبرد بيرفورمانس",
  "Train Smarter, Perform Better": "تدرّب بذكاء وارتقِ بأدائك",
  "Hybrid Performance Academy is a digital training platform designed to remove confusion from strength and performance training through structured, science-based online education.": "أكاديمية هايبرد بيرفورمانس منصة تدريب رقمية تضع بين يديك تعليماً منظماً قائماً على أسس علمية، لتجعل تدريب القوة والأداء أكثر وضوحاً وفاعلية.",
  "Our Mission": "رسالتنا",
  "Our Vision": "رؤيتنا",
  "Our mission is to provide athletes, coaches, and fitness enthusiasts with clear, practical, and progressive online training content. We focus on strength, conditioning, and performance principles that actually work — without trends, hype, or guesswork.": "رسالتنا أن نقدّم للرياضيين والمدربين ومحبي اللياقة محتوى تدريبياً رقمياً واضحاً وعملياً ومتدرجاً، يرتكز على مبادئ مثبتة في القوة والإعداد البدني وتطوير الأداء، بعيداً عن المبالغات والحلول العشوائية.",
  "Our vision is to become a trusted global platform for hybrid performance education, where users can access high-quality video libraries, structured programs, and intelligent recommendations tailored to their goals and subscriptions.": "رؤيتنا أن نصبح منصة عالمية موثوقة لتعليم الأداء الهجين، تتيح للمستخدمين مكتبات مرئية عالية الجودة وبرامج منظمة وتوصيات ذكية تناسب أهدافهم وباقاتهم.",
  "Need guidance?": "هل تحتاج إلى توجيه؟",
  "Online Support Available": "الدعم متاح عبر الإنترنت",
  "Performance in action": "الأداء على أرض الواقع",
  "Expert-led coaching": "تدريب بإشراف مختصين",
  "Explore on-demand training": "استكشف التدريب عند الطلب",
  "Included with your package": "متاح ضمن باقتك",
  "Download your nutrition guide as a PDF and keep it available on any device.": "حمّل دليل التغذية بصيغة PDF واحتفظ به على أي جهاز.",
  "Preparing Download...": "جارٍ تجهيز التحميل...",
  "Download Nutrition Guide": "تحميل دليل التغذية",
  "Your active package no longer includes this guide.": "لم يعد دليل التغذية مشمولاً في باقتك النشطة.",
  "The guide could not be downloaded. Please try again.": "تعذّر تحميل الدليل. يرجى المحاولة مرة أخرى.",
  "Videos for this subcategory will be added soon.": "ستتم إضافة مقاطع لهذا التصنيف الفرعي قريباً.",
  "Checking your package access…": "جارٍ التحقق من صلاحية باقتك…",
  "Package feature": "ميزة ضمن الباقة",
  "Package Feature": "ميزة ضمن الباقة",
  "This feature is available only with eligible packages. Choose an eligible package or ask the academy team to add it to your subscription.": "هذه الميزة متاحة ضمن الباقات المؤهلة فقط. اختر باقة مناسبة أو تواصل مع فريق الأكاديمية لإضافتها إلى اشتراكك.",
  "Explore Eligible Packages": "استعرض الباقات المؤهلة",
  "Loading...": "جارٍ التحميل...",
  "Welcome Back": "مرحباً بعودتك",
  "Create Your Account": "أنشئ حسابك",
  "Login": "تسجيل الدخول",
  "Sign Up": "إنشاء حساب",
  "Full Name": "الاسم الكامل",
  "Phone Number": "رقم الهاتف",
  "Country": "الدولة",
  "City": "المدينة",
  "Street": "الشارع",
  "Building": "المبنى",
  "Training Sessions Per Week": "عدد الحصص التدريبية أسبوعياً",
  "Email Address": "البريد الإلكتروني",
  "Confirm Password": "تأكيد كلمة المرور",
  "Logging in": "جارٍ تسجيل الدخول",
  "Creating account": "جارٍ إنشاء الحساب",
  "Create Account": "إنشاء الحساب",
  "Don’t have an account?": "ليس لديك حساب؟",
  "Sign up": "أنشئ حساباً",
  "Already have an account?": "لديك حساب بالفعل؟",
  "Authentication failed": "تعذّر تسجيل الدخول. تحقق من بياناتك وحاول مجدداً.",
  "Step 1 of 2": "الخطوة 1 من 2",
  "Reset your password": "استعادة كلمة المرور",
  "Enter your account email and we will send you a secure reset link.": "أدخل البريد الإلكتروني المرتبط بحسابك وسنرسل إليك رابطاً آمناً لإعادة تعيين كلمة المرور.",
  "Email address": "البريد الإلكتروني",
  "Sending reset link": "جارٍ إرسال الرابط",
  "Email me a reset link": "أرسل رابط الاستعادة",
  "The reset email could not be sent. Please try again.": "تعذّر إرسال رسالة الاستعادة. يرجى المحاولة مرة أخرى.",
  "Step 2 of 2": "الخطوة 2 من 2",
  "Choose a new password": "اختر كلمة مرور جديدة",
  "Resetting the password for {email}.": "تتم إعادة تعيين كلمة المرور للحساب {email}.",
  "This reset link is incomplete. Request a new password reset email.": "رابط الاستعادة غير مكتمل. اطلب رسالة جديدة لإعادة تعيين كلمة المرور.",
  "Redirecting to login...": "سيتم تحويلك إلى صفحة تسجيل الدخول...",
  "Confirm new password": "تأكيد كلمة المرور الجديدة",
  "Resetting password": "جارٍ تحديث كلمة المرور",
  "Request a new link": "طلب رابط جديد",
  "The password confirmation does not match.": "كلمتا المرور غير متطابقتين.",
  "This reset link is invalid or has expired.": "رابط الاستعادة غير صالح أو انتهت صلاحيته.",
  "Exercise Libraries": "مكتبات التمارين",
  "Explore structured training systems designed to organise strength, performance, and mobility exercises.": "استكشف أنظمة تدريبية منظمة تجمع تمارين القوة والأداء والحركة ضمن مسارات واضحة.",
  "No libraries available.": "لا تتوفر مكتبات حالياً.",
  "Platform": "منصة",
  "One place for every library, plan and training session.": "مكان واحد يجمع كل المكتبات والباقات والجلسات التدريبية.",
  "Exercises": "تمارين",
  "Movements, drills, and progressions across the platform.": "حركات وتمارين وتدرجات تدريبية متنوعة عبر المنصة.",
  "Hypertrophy, athletic performance, mobility and kettlebell.": "بناء العضلات، الأداء الرياضي، الحركة، والتدريب بالكرة الحديدية.",
  "Custom Program": "برنامج مخصص",
  "Your personalized blueprint, built around your goals.": "مخططك التدريبي الشخصي المبني حول أهدافك.",
  "Training": "التدريب",
  "Beginner": "مبتدئ",
  "Nutrition": "التغذية",
  "Fat Loss": "خسارة الدهون",
  "Intermediate": "متوسط",
  "Muscle Gain": "بناء العضلات",
  "Recovery": "الاستشفاء",
  "All Levels": "جميع المستويات",
  "Cardio": "التمارين الهوائية",
  "Coach Answered": "إجابة المدرب",
  "FAQ": "سؤال شائع",
  "View Answer": "عرض الإجابة",
  "View All FAQs": "عرض جميع الأسئلة",
  "How many days per week should I train?": "كم يوماً ينبغي أن أتدرّب أسبوعياً؟",
  "Most beginners should aim for 3–4 sessions per week for optimal recovery.": "يناسب معظم المبتدئين أداء 3 إلى 4 حصص أسبوعياً لضمان استشفاء جيد.",
  "Do I need protein supplements?": "هل أحتاج إلى مكملات البروتين؟",
  "Not necessarily. You can meet your needs through whole foods if your diet is balanced.": "ليس بالضرورة؛ يمكن لنظام غذائي متوازن أن يوفّر احتياجك من البروتين عبر الأطعمة الطبيعية.",
  "Why am I not losing weight despite training?": "لماذا لا ينخفض وزني رغم التدريب؟",
  "Calories, sleep, stress, and consistency all play a bigger role than workouts alone.": "السعرات والنوم والتوتر والاستمرارية عوامل مؤثرة، ولا يعتمد التقدم على التمرين وحده.",
  "How long does it take to build muscle?": "كم يستغرق بناء العضلات؟",
  "Visible changes usually appear after 4–8 weeks of consistent training.": "تبدأ النتائج الملحوظة عادة بعد 4 إلى 8 أسابيع من التدريب المنتظم.",
  "Is rest day really important?": "هل يوم الراحة مهم فعلاً؟",
  "Yes. Recovery is where muscles grow and injuries are prevented.": "نعم؛ فالاستشفاء ضروري لنمو العضلات وتقليل خطر الإصابات.",
  "Should I do cardio before or after weights?": "هل أمارس التمارين الهوائية قبل الأوزان أم بعدها؟",
  "After weights if your main goal is strength or muscle growth.": "بعد تمارين الأوزان إذا كان هدفك الأساسي زيادة القوة أو بناء العضلات.",
  "Share your experience": "شاركنا تجربتك",
  "Leave feedback as {name}": "أضف تقييمك باسم {name}",
  "Your account name will be shown automatically with your feedback.": "سيظهر الاسم المسجّل في حسابك تلقائياً مع تقييمك.",
  "Rating": "التقييم",
  "{count} stars": "{count} نجوم",
  "Your feedback": "رأيك",
  "Tell others about your experience with the academy...": "شارك الآخرين تجربتك مع الأكاديمية...",
  "Publishing...": "جارٍ النشر...",
  "Publish Feedback": "نشر التقييم",
  "Thank you. Your feedback is now displayed.": "شكراً لك. تم نشر تقييمك.",
  "Your feedback could not be submitted. Please try again.": "تعذّر نشر تقييمك. يرجى المحاولة مرة أخرى.",
  "/ Month": "/ شهر",
  "/ 2 Months": "/ شهرين",
  "/ 3 Months": "/ 3 أشهر",
  "/ 6 Months": "/ 6 أشهر",
  "/ Year": "/ سنة",
  "/ {days} Days": "/ {days} يوماً",
  "Build your access": "خصّص وصولك",
  "Choose exactly {count} libraries. Your subscription will unlock only your selected libraries.": "اختر {count} من المكتبات. سيتيح اشتراكك الوصول إلى المكتبات التي تحددها فقط.",
  "{selected} of {required} selected": "تم اختيار {selected} من {required}",
  "Preparing payment…": "جارٍ تجهيز عملية الدفع…",
  "Continue to Payment": "المتابعة إلى الدفع",
  "Gives Access To": "تتيح الوصول إلى",
  "Get Access": "احصل على الباقة",
  "Loading plans…": "جارٍ تحميل الباقات…",
  "LIFT SMART": "ارتقِ بتدريبك",
  "Train With Purpose": "تدرّب بهدف",
  "Structured online education for strength, performance, and long-term progress.": "تعليم تدريبي منظم للقوة والأداء والتطور المستدام.",
  "Explore the Platform": "استكشف المنصة",
  "How It Works": "كيف تعمل المنصة",
  "WHAT YOU GET": "ما الذي ستحصل عليه",
  "Platform Features": "مزايا المنصة",
  "Ready to start training with structure?": "هل أنت مستعد لتدريب أكثر تنظيماً؟",
  "Browse the full library catalogue and find the right programme for your goals.": "تصفّح مكتباتنا واختر البرنامج الأنسب لأهدافك.",
  "Browse Libraries": "تصفّح المكتبات",
  "Choose a Package": "اختر باقتك",
  "Explore Categories": "استكشف التصنيفات",
  "Watch & Train": "شاهد وتدرّب",
  "HD Video Library": "مكتبة فيديو عالية الدقة",
  "Subscription Access": "وصول وفق الاشتراك",
  "Any Device, Any Time": "على أي جهاز وفي أي وقت",
  "Structured Content": "محتوى منظم",
  "Evidence-Based Methods": "منهجيات قائمة على الدليل",
  "Direct Support": "دعم مباشر",
  "Hybrid Training Systems": "أنظمة التدريب الهجين",
  "Sport-Specific Education": "تدريب متخصص حسب الرياضة",
  "Conditioning & Mobility": "الإعداد البدني والحركة",
  "Program Design Fundamentals": "أساسيات تصميم البرامج",
  "Injury-Resilient Training Principles": "مبادئ التدريب للحد من الإصابات",
  "Performance Analytics & Progress Tracking": "تحليل الأداء ومتابعة التقدم",
  "On-Demand Video Library": "مكتبة فيديو عند الطلب",
  "STRENGTH": "القوة",
  "BUILD": "ابنِ",
  "POWER": "القدرة",
  "UNLEASH": "أطلق",
  "YOUR POWER": "قوتك",
  "PERFORMANCE": "الأداء",
  "ELEVATE": "ارتقِ",
  "DISCIPLINE": "الانضباط",
  "STAY": "حافظ على",
  "DISCIPLINED": "انضباطك",
  "Explore Libraries": "استكشف المكتبات",
  "Learn More": "اعرف المزيد",
  "Show slide {number}": "عرض الشريحة {number}",
  "Every rep, every set - progress is built in the details. Show up and do the work.": "كل تكرار وكل مجموعة يصنعان الفارق؛ التزم بالحضور وأنجز العمل.",
  "Explosive, intentional, unstoppable. Power isn't given - it's earned through consistency.": "تحرّك بقوة ووعي وثبات؛ فالقدرة لا تُمنح، بل تُبنى بالاستمرارية.",
  "Train with purpose. Every session is an opportunity to become a better version of yourself.": "تدرّب بهدف؛ فكل حصة فرصة لتصبح نسخة أفضل من نفسك.",
  "Champions aren't made on their best days. They're built in the quiet moments of commitment.": "الأبطال لا تصنعهم الأيام السهلة، بل لحظات الالتزام التي لا يراها أحد.",
  "Login Required": "تسجيل الدخول مطلوب",
  "Please log in to view your personalised workout schedule.": "يرجى تسجيل الدخول لعرض جدولك التدريبي المخصص.",
  "Loading your schedule…": "جارٍ تحميل جدولك…",
  "Personalised": "مخصص لك",
  "My Workout Schedule": "جدولي التدريبي",
  "Your coach has prepared this weekly plan just for you.": "أعدّ مدربك هذه الخطة الأسبوعية خصيصاً لك.",
  "Health & Fitness Tools": "أدوات الصحة واللياقة",
  "Body Metrics Calculator": "حاسبة مؤشرات الجسم",
  "Calculate your BMI, BMR, daily calorie needs, and personalised macros in seconds.": "احسب مؤشر كتلة الجسم ومعدل الأيض واحتياجك اليومي من السعرات والمغذيات خلال ثوانٍ.",
  "Step 1": "الخطوة 1",
  "Step 2": "الخطوة 2",
  "Step 3": "الخطوة 3",
  "Your Body Stats": "بيانات جسمك",
  "Activity Level": "مستوى النشاط",
  "Your Goal": "هدفك",
  "Calculate My Metrics": "احسب مؤشراتي",
  "Your Results": "نتائجك",
  "Your Personalised Metrics": "مؤشراتك الشخصية",
  "BMI Gauge": "مؤشر كتلة الجسم",
  "BMI Reference Chart": "الجدول المرجعي لمؤشر الكتلة",
  "BMI Range": "نطاق المؤشر",
  "Status": "الحالة",
  "You are here": "نتيجتك هنا",
  "Sedentary": "قليل الحركة",
  "Lightly Active": "نشاط خفيف",
  "Moderately Active": "نشاط متوسط",
  "Very Active": "نشاط مرتفع",
  "Extra Active": "نشاط مكثف",
  "Maintain Weight": "الحفاظ على الوزن",
  "Lose Fat": "خسارة الدهون",
  "Gain Muscle": "بناء العضلات",
  "Get In Touch": "يسعدنا تواصلك",
  "Have a question, want to collaborate, or need to report an issue? Fill out the form and send your details directly through WhatsApp.": "لديك استفسار أو ترغب في التعاون أو الإبلاغ عن مشكلة؟ عبّئ النموذج وأرسل التفاصيل مباشرة عبر واتساب.",
  "General Inquiry": "استفسار عام",
  "Technical Support": "الدعم الفني",
  "Partnership / Collaboration": "شراكة أو تعاون",
  "WhatsApp Message Ready!": "رسالتك جاهزة على واتساب",
  "Your details were prepared in WhatsApp. Send the message there to reach us directly.": "تم تجهيز تفاصيلك في واتساب. أرسل الرسالة من التطبيق للتواصل معنا مباشرة.",
  "Send Another": "إرسال رسالة أخرى",
  "Professional Role / Industry": "المجال أو الصفة المهنية",
  "Primary Goal": "الهدف الأساسي",
  "Select your goal": "اختر هدفك",
  "Time Commitment": "الوقت المتاح",
  "Select weekly time": "اختر الوقت الأسبوعي",
  "Why Applying Today?": "ما الذي يدفعك للبدء اليوم؟",
  "Mobile Number": "رقم الهاتف",
  "Preferred Contact Method": "وسيلة التواصل المفضلة",
  "Choose a method": "اختر وسيلة التواصل",
  "Are you ready to commit to a premium results driven coaching program?": "هل أنت مستعد للالتزام ببرنامج تدريبي احترافي يركز على النتائج؟",
  "Your Name": "اسمك",
  "Subject": "الموضوع",
  "Message": "الرسالة",
  "Opening WhatsApp...": "جارٍ فتح واتساب...",
  "Send via WhatsApp": "إرسال عبر واتساب",
  "Type": "نوع الطلب",
  "Mobile call": "اتصال هاتفي",
  "WhatsApp": "واتساب",
  "Text message": "رسالة نصية",
  "Program Inquiry": "طلب برنامج تدريبي",
  "Start with the right plan": "ابدأ بالخطة المناسبة",
  "Training Program Inquiry": "طلب برنامج تدريبي",
  "Tell us about your goals, experience, and availability so our coaching team can guide you toward the right program.": "أخبرنا عن أهدافك وخبرتك والوقت المتاح لديك، ليتمكن فريق التدريب من توجيهك إلى البرنامج الأنسب.",
  "Send Program Inquiry": "إرسال طلب البرنامج",
  "Your program inquiry is ready in WhatsApp. Send it there to reach our coaching team.": "تم تجهيز طلبك في واتساب. أرسل الرسالة من التطبيق للتواصل مباشرة مع فريق التدريب.",
  "Read your nutrition guide securely without leaving the academy platform.": "اطّلع على دليل التغذية بأمان من داخل منصة الأكاديمية.",
  "Opening nutrition guide…": "جارٍ فتح دليل التغذية…",
  "The guide could not be opened. Please try again.": "تعذّر فتح الدليل. يرجى المحاولة مرة أخرى.",
  "Subscribe to Access": "اشترك للوصول",
  "Choose a package to unlock {name}": "اختر باقة لفتح مكتبة {name}",
  "Please wait…": "يرجى الانتظار…",
  "Included in your plan": "مشمولة في باقتك",
  "Package access": "متاحة ضمن الباقات",
  "Explore a structured exercise database organized for professional training and performance development.": "استكشف قاعدة تمارين منظمة لتطوير الأداء والتدريب الاحترافي.",
  "Open Library": "فتح المكتبة",
  "View Access Options": "عرض خيارات الوصول",
  "Loading libraries…": "جارٍ تحميل المكتبات…",
  "No libraries available": "لا تتوفر مكتبات حالياً",
  "New training libraries will appear here when they are published.": "ستظهر المكتبات التدريبية الجديدة هنا عند نشرها.",
  "Notifications": "الإشعارات",
  "Notifications ({count} unread)": "الإشعارات ({count} غير مقروء)",
  "Mark all as read": "تعليم الكل كمقروء",
  "Mark as read": "تعليم كمقروء",
  "Dismiss": "إزالة",
  "Open": "فتح",
  "You have no notifications yet.": "لا توجد إشعارات حتى الآن.",
  "Could not load your notifications. Please try again.": "تعذر تحميل الإشعارات. يرجى المحاولة مجدداً.",
};
